const Sage = window.Sage;

// Modules
import Common from "./modules/common";
import Animate from "./modules/animate";
import Header from "./modules/header";
import HeaderSearch from "./modules/header-search";
import Lightbox from "./modules/lightbox";
import OutdatedBrowser from "./modules/outdated-browser";
import Youtube from "./modules/youtube";
import FloatingMenu from "./modules/floating-menu";

// Autoload modules
const modules = [
  Common,
  Animate,
  Header,
  HeaderSearch,
  Lightbox,
  OutdatedBrowser,
  Youtube,
  FloatingMenu,
];

modules.forEach((module) => {
  module.init();
});

// import local dependencies
import Router from "./utils/Router";
import blocks from "./modules/blocks";
import singlePost from "./partials/single-post";
import singleToolbox from "./partials/single-toolbox";
import templateToolbox from "./partials/template-toolbox";
import templateContacts from "./partials/template-contacts";
import templateDiasporaForm from "./partials/template-diaspora-form";
import category from "./partials/category";

// Populate Router instance with DOM routes
const routes = new Router({
  pageTemplateDefault: blocks,
  templateHome: blocks,
  templateParent: blocks,
  templateToolbox,
  templateContacts,
  templateDiasporaForm,
  singlePost,
  singleToolbox,
  category,
});

// Load Events
routes.loadEvents();
